import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-legends-info',
    templateUrl: './legends-info.component.html',
    styleUrls: ['./legends-info.component.sass'],
    standalone: false
})
export class LegendsInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
